<template>
    <div class="w-full h-full shadow-md p-3">
      <div class="w-full flex justify-center">
        <img class="w-24" src="../assets/logo.png" alt="logo phiphitoys">
      </div>
      <h1 class="text-xl">Esta pagina se encuentra fuera de servicio temporalmente</h1>
      <p>Estamos trabajando para retomar el funcionamiento habitual lo antes posible.</p><br>
      <p>De ser necesario podes contactarte con Phi Phi Toys por los medios alternativos.</p>
      <div class="h-10"></div>
      <a class="mt-5" :href="'mailto:' + mail">{{ mail }}</a>
      <p>{{ tel }}</p>
    </div>
  </template>
  
  <script>
import configService from '@/services/config.service';

  export default {
    data() {
      return {
        mail: '',
        tel: ''
      };
    },
    computed: {
    },
    methods: {
        buscarContactos() {
          configService.getContacto()
            .then(res => {
              this.mail = res.data.find(x => x.clave == 'CONTACTO_MAIL').valor
              this.tel = res.data.find(x => x.clave == 'CONTACTO_TEL').valor
            })
            .catch(err => {
              console.log(err)
            })
        }
    },
    mounted() {
      this.buscarContactos()
    },
  };
  </script>

